

















































































import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import { Curator } from "types/curator"
import EditDialog from "@/components/Curators/EditDialog.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"

import { DataTableHeader } from "vuetify/types"

@Component({
  components: { EditDialog, TableItemIsEnabled },
})
export default class Curators extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "名前", value: "name" },
      { text: "Twitter", value: "twitterUrl" },
      { text: "YouTube", value: "youtubeUrl" },
      { text: "Instagram", value: "instagramUrl" },
      { text: "その他のURL", value: "linkUrl" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  private loading = true
  private dialog = false
  private searchName = ""
  private curators: Curator["view"][] = []

  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public created(): void {
    this.loading = false
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    this.getCurators()
  }

  private getCurators(_page?: number) {
    const page = _page ? _page : this.pagination.page
    const per = 10
    const sortBy = this.pagination.sortBy[0]
    const descending = this.pagination.sortDesc[0]

    api
      .getCurators({
        name: this.searchName,
        page,
        per,
        sortBy,
        descending,
      })
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.curators = res.data.curators
      })
      .catch(() => {
        this.$toasted.error("著名人一覧の取得に失敗しました")
      })
      .finally(() => {
        this.loading = false
      })
  }

  private search() {
    this.loading = true
    if (this.pagination.page === 1) {
      this.getCurators()
    } else {
      this.resetPagination()
    }
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private updateCurator(updatedCurator: Curator["view"]) {
    const old = this.curators.find(
      (oldCurator) => oldCurator.id === updatedCurator.id
    )

    if (old) {
      old.name = updatedCurator.name
      old.thumbnailImage = updatedCurator.thumbnailImage
      old.twitterUrl = updatedCurator.twitterUrl
      old.instagramUrl = updatedCurator.instagramUrl
      old.youtubeUrl = updatedCurator.youtubeUrl
      old.linkUrl = updatedCurator.linkUrl
      this.$toasted.success("著名人情報を更新しました")
    } else {
      if (this.pagination.page > 1) {
        this.pagination.page = 1 // Watchされていることに注意
      } else {
        this.getCurators()
      }
      this.$toasted.success("著名人情報を新規作成しました")
    }
  }

  private deleteCurator(page: number) {
    this.getCurators(page)
    this.$toasted.success("著名人情報を削除しました")
  }

  private async open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof EditDialog>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof EditDialog>
      newDialog.open()
    }
  }
}
